import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToHash } from "./Navbar";
import { BRAND, NAV_LINKS } from "../data/content";

export const Footer = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer data-testid="footer-section" className="bg-coal text-white">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8 lg:py-20">
          <div className="sm:col-span-2">
            <Logo inverse />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
              Constructora integral que transforma planos en infraestructuras
              tangibles, con solidez técnica y gestión transparente.
            </p>
          </div>
          <nav aria-label="Navegación del pie de página">
            <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-cafe">
              Navegación
            </span>
            <ul className="mt-5 space-y-3">
              {[...NAV_LINKS, { label: "Contacto", hash: "#contacto" }].map((l) => (
                <li key={l.hash}>
                  <a
                    href={l.hash}
                    data-testid={`footer-link-${l.hash.slice(1)}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToHash(l.hash);
                    }}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-cafe"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-cafe">
              Contacto
            </span>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li data-testid="footer-address" className="leading-relaxed">{BRAND.address}</li>
              <li>
                <a href={`tel:+52${BRAND.phone.replace(/\s/g, "")}`} className="transition-colors duration-300 hover:text-cafe">
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="transition-colors duration-300 hover:text-cafe">
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-4 py-6 font-mono text-[10px] uppercase tracking-[0.25em] text-white/45 sm:flex-row sm:items-center sm:px-6 lg:px-8">
            <span data-testid="footer-copyright">
              © 2026 OESCA Construcciones · {BRAND.location}
            </span>
            <span>{BRAND.web}</span>
          </div>
        </div>
      </footer>

      <button
        data-testid="back-to-top-button"
        onClick={() => scrollToHash("#inicio")}
        aria-label="Volver arriba"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-cafe-dark text-white shadow-lg shadow-cafe-dark/25 transition-[opacity,transform,background-color] duration-500 hover:bg-cafe ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <ArrowUp className="h-5 w-5" />
      </button>
    </>
  );
};
